/** Shared dark shell for hero, flow, and pillars bands. */
const marketingDarkSectionShell =
  "dark:bg-[var(--marketing-dark-canvas)] dark:text-white";

export const marketingHeroSectionClass = `relative overflow-hidden bg-background text-foreground ${marketingDarkSectionShell}`;

export const marketingFlowSectionClass = `relative overflow-hidden section-muted text-foreground ${marketingDarkSectionShell}`;

export const marketingPillarsSectionClass = `relative overflow-hidden bg-background text-foreground ${marketingDarkSectionShell}`;

export const marketingBentoSectionClass =
  "relative bg-background text-foreground dark:bg-background";

export const marketingFaqSectionClass =
  "relative section-muted text-foreground dark:bg-background";

export const marketingSocialProofSectionClass =
  "relative overflow-hidden section-muted text-foreground dark:bg-[var(--marketing-dark-social)] dark:text-white";

export const marketingPersonasSectionClass =
  "relative overflow-hidden bg-background text-foreground dark:bg-background";

export const marketingPricingSectionClass =
  "relative bg-background text-foreground dark:bg-[var(--marketing-dark-canvas)] dark:text-white";

export const marketingPricingPageSectionClass =
  "relative section-muted text-foreground dark:bg-[var(--marketing-dark-canvas)] dark:text-white";

export const marketingGridOverlayClass =
  "pointer-events-none absolute inset-0 opacity-20 dark:opacity-20";

export const marketingGridOverlayStyle = {
  backgroundImage:
    "linear-gradient(rgba(0,0,0,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(0,0,0,0.04) 1px, transparent 1px)",
  backgroundSize: "64px 64px",
} as const;

export const marketingGridOverlayDarkStyle = {
  backgroundImage:
    "linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)",
  backgroundSize: "64px 64px",
} as const;

/** Subtle card edges  -  light zinc tint; dark low-contrast white. */
export const marketingCardBorderClass =
  "border-zinc-200/50 dark:border-white/[0.05]";

/** Dividers, chips, and inner panels on marketing UI. */
export const marketingSubtleBorderClass =
  "border-zinc-200/50 dark:border-white/[0.05]";

export const marketingDividerBorderClass =
  "border-zinc-200/45 dark:border-white/[0.05]";

/** Borders inside always-dark mockups (schedule table, script editor chrome). */
export const marketingDarkUiBorderClass = "border-white/[0.05]";

/** Hover border for idle marketing cards (light only; dark keeps existing token). */
export const marketingCardHoverBorderClass =
  "hover:border-zinc-300/45 dark:hover:border-white/[0.06]";

export const marketingCardClass = `rounded-xl border bg-card/60 backdrop-blur-sm dark:bg-[var(--marketing-dark-card)] ${marketingCardBorderClass}`;

export const marketingMutedTextClass =
  "text-muted-foreground dark:text-white/55";

export const marketingSubtleTextClass =
  "text-muted-foreground dark:text-white/60";

export const marketingFloatingCardClass = `surface-elevated overflow-hidden rounded-xl border bg-card dark:bg-[var(--marketing-dark-card)] ${marketingCardBorderClass}`;

export const marketingBrowserChromeClass = `surface-elevated relative z-10 overflow-hidden rounded-xl border bg-card dark:bg-[#101010] ${marketingCardBorderClass}`;

export const marketingConversionSectionClass =
  "section-muted text-foreground dark:section-dark dark:bg-[var(--marketing-dark-conversion)] dark:text-white";

export const marketingSectionDividerClass =
  "pointer-events-none absolute inset-x-0 top-0 h-px bg-zinc-200/45 dark:bg-white/[0.05]";
